import ListingItem from './ListingItem';

const ListingSection = props => <ListingItem>{props.children}</ListingItem>;

ListingSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  children: ListingItem.propTypes.children
};

export default ListingSection;
